import * as actionType from "./constants";
const initialState = {
    getMenuItemsResponse: {},
    menuSearchResponse: {},
    menuSearchLoading: false,
    getEmailItemResponse: {},
    // getProjectMenuItemsResponse:{},
    // getReportMenuItemsResponse:{},
    isFormDirty: false,
    pendingAction: null,
    showUnsavedPrompt: false,
    currency: localStorage.getItem("currency") || "USD",
    showFcaNoticePrompt: false,
    pendingCancelAction: null
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_MENU_ITEMS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_MENU_ITEMS_SUCCESS:
            return {
                ...state,
                getMenuItemsResponse: { success: true, ...action.response }
            };
        case actionType.GET_MENU_ITEMS_FAILURE:
            return {
                ...state,
                getMenuItemsResponse: { success: false, ...action.error }
            };
        case actionType.GET_EXPORT_ITEMS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_EXPORT_ITEMS_SUCCESS:
            return {
                ...state,
                getExportItems: { success: true, ...action.response }
            };
        case actionType.GET_EXPORT_ITEMS_FAILURE:
            return {
                ...state,
                getExportItems: { success: false, ...action.error }
            };
        case actionType.ADD_EXPORT_ITEMS_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_EXPORT_ITEMS_SUCCESS:
            return {
                ...state,
                AddExportItems: { success: true, ...action.response }
            };
        case actionType.ADD_EXPORT_ITEMS_FAILURE:
            return {
                ...state,
                AddExportItems: { success: false, ...action.error }
            };
        case actionType.GET_PROJECT_MENU_ITEMS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_PROJECT_MENU_ITEMS_SUCCESS:
            return {
                ...state,
                [action.key]: { success: true, ...action.response }
            };
        case actionType.GET_PROJECT_MENU_ITEMS_FAILURE:
            return {
                ...state
                // getProjectMenuItemsResponse: { success: false, ...action.error }
            };
        case actionType.SEARCH_MENU_ITEMS_REQUEST:
            return {
                ...state,
                menuSearchLoading: true,
                menuSearchResponse: {
                    ...state.menuSearchResponse,
                    query: action.query,
                    error: null
                }
            };
        case actionType.SEARCH_MENU_ITEMS_SUCCESS:
            return {
                ...state,
                ...(action.query === state.menuSearchResponse.query
                    ? {
                          menuSearchLoading: false,
                          menuSearchResponse: {
                              success: true,
                              ...action.response,
                              query: action.query
                          }
                      }
                    : {})
            };
        case actionType.SEARCH_MENU_ITEMS_FAILURE:
            return {
                ...state,
                menuSearchLoading: false,
                menuSearchResponse: {
                    success: false,
                    query: action.query,
                    error: action.error
                }
            };

        case actionType.SET_FORM_DIRTY_SUCCESS:
            return {
                ...state,
                isFormDirty: action.response
            };
        case actionType.SET_FORM_DIRTY_FAILURE:
            return {
                ...state,
                isFormDirty: action.error
            };
        case actionType.SET_PENDING_ACTION:
            return {
                ...state,
                pendingAction: action.payload
            };
        case actionType.SET_PENDING_CANCEL_ACTION:
            return { ...state, pendingCancelAction: action.payload };
        case actionType.SHOW_UNSAVED_PROMPT:
            return {
                ...state,
                showUnsavedPrompt: action.payload
            };
        case actionType.GET_MENU_LINK_EMAIL_REQUEST:
            return {
                ...state
            };
        case actionType.GET_MENU_LINK_EMAIL_SUCCESS:
            return {
                ...state,
                getEmailItemResponse: { success: true, ...action.response }
            };
        case actionType.GET_MENU_LINK_EMAIL_FAILURE:
            return {
                ...state,
                getEmailItemResponse: { success: false, ...action.error }
            };
        case actionType.CHANGE_CURRENCY:
            return { ...state, currency: action.payload };
        case actionType.TRIGGER_FCA_NOTICE_PROMPT:
            return { ...state, showFcaNoticePrompt: action.payload };
        default:
            return state;
    }
};
export default reducers;
